/*
 * @Author: Kuaiyin FE
 * @Date: 2020-07-08 18:09:47
 * @Description: Android 桥接方法定义
 * @FilePath: /kuaiyin-h5/src/sdk/android_sdk.js
 */
const userInfo = require('./user-info.json');
import store from '../store/index';
import sdk from '../sdk';
import { trackClick } from '@/lib/track';

/**
 * @description: 定义安卓监听方法常量
 */
const androidMethodObj = {
	ON_SHOW: 'onShow',
	ON_HIDDEN: 'onHidden',
	ON_REWARD_VIDEO_PLAYED: 'onRewardVideoPlayEnd',
	ON_MUSIC_ACTION: 'onMusicAction',
	ON_BIND_WE_CHAT_ACCOUNT: 'onBindWeChatAccount',
	ON_CALENDAR_CALLBACK: 'onCalendarCallBack',
	ON_REWARD_VIDEO_PLAY_FAILED: 'onRewardVideoPlayFailed',
	ON_REWARD_VIDEO_JUMP: 'onRewardVideoJump',
	ON_UPLOAD_SUCCESS: 'onUploadSuccess',
	/**
	 * @description: 监听恭喜获得模块相关事件
	 * @param {string} event - onCongratulationsPopWindow回调的参数  'show'--弹窗打开 'dismiss'--弹窗关闭 'playVideo'--开始看视频 'playVideoComplete'--看完视频 'playVideoCompleteSkip'--跳过视频
	 * @return {void}
	 */
	ON_CONGRATULATIONS_POPWINDOW: 'onCongratulationsPopWindow',
	ON_MONITOR_URL_TASK: 'onMonitorUrlTask', // 监控 URL 进度任务回调
	ON_PAY_RESULT: 'onPayResult', // 支付完成回调事件
	// 5.2.0的插屏广告失败回调
	ON_AD_EXPOSURE_FAILURE: 'onAdExposureFailure',
	// 5.3.0以上的插屏广告失败回调
	ON_AD_RENDER_ERROR: 'onAdRenderError',
	// 插屏广告曝光
	ON_AD_EXPOSURE: 'onAdExposure',
	// 插屏广告点击
	ON_AD_CLICK: 'onAdClick',
	// 支付宝绑定回调
	ON_BIND_ALIPAY_SDK_CALLBACK: 'onBindAlipaySDKCallback',
};

/**
 * @description: 定义bridge原生方法名
 */
const androidAppCallObj = {
	BIND_WECHAT_ACCOUNT: 'bindWeChatAccount',
	IS_CALENDAR_ENABLED: 'isCalendarEnabled',
	HANDLE_CALENDAR: 'handleCalendar',
	OPEN_PAGE_WITH_JSON: 'openPageWithJSON',
	OPEN_TIP_AD_GAME: 'openTipAdGame',
	TOAST: 'toast',
	COPY: 'copy',
	SHARE_TO: 'shareTo',
	SET_TITLE: 'setTitle',
	CLOSE_WEBVIEW: 'closeWebView',
	GET_USER_INFO: 'getUserInfo',
	PRELOAD_ADS: 'preLoadAds',
	SHOW_REWARD_VIDEO_AD_WITH_JSON: 'showRewardVideoAdWithJSON',
	INIT_MUSIC_PLAYER_LIST: 'initMusicPlayerList',
	APPEND_MUSIC_PLAYER_LIST: 'appendMusicPlayerList',
	HANDLE_MUSIC_BY_ACTION: 'handleMusicByAction',
	UPLOAD_OPUS: 'uploadOpus',
	OPEN_BXM_GAME_DIALOG: 'openBxmGameDialog',
	IS_NOTIFICATION_ENABLED: 'isNotificationEnabled',
	OPEN_NOTIFICATION: 'openNotification',
	IS_MUSIC_PLAYING: 'isMusicPlaying',
	PAUSE_MUSIC: 'pauseMusic',
	PLAY_MUSIC: 'playMusic',
	SIGN_CONTENT: 'signContent',
	OPEN_NATIVE_PAGE: 'openNativePage',
	LAUNCH_APP_DETAILS_SETTINGS: 'launchAppDetailsSettings',
	U_TRACK: 'UTrack',
	OPEN_NOVEL: 'openNovel',
	REFRESH_TOKEN: 'refreshToken',
	LOAD_INTERACTION_AD: 'loadInteractionAd',
	/**
	 * @description: 聚合平台广告调用方法
	 * @param {number} groupId - 广告组ID
	 * @param {string} extras - 额外参数
	 * @return void
	 */

	LOAD_MEDIATION_AD: 'loadMediationAd',
	/**
	 * @description: 充值完成回调
	 * @param: {boolean} status - 充值结果
	 */

	RECHARGE_STATUS: 'rechargeStatus',
	OPEN_FU_NENG_GAME: 'onPowerClick',
	/**
	 * @description: 打开手机应用市场
	 */
	OPEN_PHONE_MARKET: 'openPhoneMarket',
	/**
	 * @description: 通知客户端用户下拉刷新
	 */
	ON_REFRESH: 'onRefresh',
	LOAD_INTERSTITIAL_AD: 'loadInterstitialAd',
	UPDATE_MOBILE: 'updateMobile',
	OPEN_VIBRATION: 'openVibration',
	ON_BIND_ALIPAY_SDK: 'alipayAuth', // 提现绑定支付宝SDK
};

/**
 * @description: 往安卓桥接对象上注入监听方法
 * @return: void
 */

const androidSdkInit = () => {
	if (window.bridge && window.bridge.setMethodList) {
		window.bridge.onCongratulationsPopWindow = () => {};
		const methodValueList = Object.values(androidMethodObj);
		window.bridge.setMethodList(JSON.stringify(methodValueList));
	}
};

/**
 * @description: 安卓桥接对象注册事件回调方法
 * @param {string} event - 时间名称
 * @param {object} callback - 回调函数
 * @param {Object} params - 回调函数参数
 * @return: void
 */

const androidRegister = (event, callback) => {
	try {
		const eventStr = androidMethodObj[event];
		console.log('eventStr', eventStr);
		if (eventStr) {
			window.bridge[eventStr] = callback;
		}
	} catch (e) {
		console.log(e);
	}
};

/**
 * @description: js 调用 bridge 原生方法
 * @param {string} appFn - 方法名
 * @param {string} param - 参数
 * @return: void
 */

const androidAppCall = (appFn, ...param) => {
	try {
		const fnStr = androidAppCallObj[appFn];
		const { bridge } = window;

		if (fnStr == 'openPageWithJSON') {
			let { client } = store.getters;

			if (!Object.keys(client).length) {
				let info = sdk.appCall('GET_USER_INFO');

				if (info) {
					client = JSON.parse(info);
				}
			}
			const app_name = client['app-name'] || 'kuaiyin';
			const regex = /^kuaiyin/;
			let paramTransform = JSON.parse(param);

			if (regex.test(paramTransform.url)) {
				let urlArr = paramTransform.url.split('://');
				if (urlArr[0] != app_name) {
					trackClick({ page_title: 'bridge', element_name: 'openPageWithJSON', remarks: `before;${paramTransform.url}` });
					urlArr[0] = app_name;
					let protocol = urlArr.splice(0, 1)[0];
					paramTransform.url = protocol + '://' + urlArr.join('');
					trackClick({ page_title: 'bridge', element_name: 'openPageWithJSON', remarks: `after;${paramTransform.url}` });
				}
			}

			// let urlTransform = paramTransform.url.replace(/kuaiyin/, app_name);
			param = [JSON.stringify(paramTransform)];
		}

		if (bridge) {
			return bridge[fnStr](...param);
		} else {
			return handleNoBridge(fnStr, ...param);
		}
	} catch (e) {
		console.log(e);
	}
};
/**
 * @description: 处理没有 bridge 的情况
 * @param {string} funcName - 方法名
 * @param {string} param - 参数
 */

const handleNoBridge = (funcName, ...param) => {
	switch (funcName) {
		case 'openPageWithJSON':
			window.location.href = JSON.parse(param).url;
			break;
		case 'getUserInfo':
			if (process.env.NODE_ENV === 'development') {
				// TODO ！！上线时打开！！
				return JSON.stringify(userInfo);
			}
			break;
		case 'signContent':
			break;
		case 'setTitle':
			if (process.env.NODE_ENV === 'development') {
				window.document.title = param;
			}
			break;
		default:
			throw Error('bridge is not defined!');
	}
};

export { androidSdkInit, androidRegister, androidAppCall };



// WEBPACK FOOTER //
// ./src/sdk/android_sdk.js